<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        ثبت درخواست خرید
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding">
      <div :class="$q.screen.lt.md?'row full-width':'row full-width q-gutter-sm'">
        <div class="col col-xs-12 col-md-5">
          <q-expansion-item
              :class="$q.screen.lt.md?'shadow-1 overflow-hidden q-mt-sm':'shadow-1 overflow-hidden'"
              style="border-radius: 10px"
              icon="shopping_cart"
              label="لیست کالاها"
              header-class="bg-indigo-10 text-white"
              expand-icon-class="text-white"
              default-opened>
            <ProductInfoSearchPanel @cancel-product-search="clearItems"/>
            <ProductInfoSearchResult :is-selection-form="true"
                                     :buy-list="true"
                                     :show-groups="true"
                                     :for-pre-request="true"
                                     :by-pass-insert-dialog="false"
                                     :pre-buy-order-request="true"
                                     description-select-good-dialog="تعداد سفارش را وارد نمایید"
                                     title-select-good-dialog="تعداد سفارش"
                                     @select-goods="selectedGood"/>
          </q-expansion-item>
        </div>
        <div class="col-xs-12 col-md-6">
          <q-expansion-item
              :class="$q.screen.lt.md?'shadow-1 overflow-hidden q-mt-sm':'shadow-1 overflow-hidden'"
              style="border-radius: 10px"
              icon="shopping_cart"
              label="اقلام سفارش"
              header-class="bg-indigo-10 text-white"
              expand-icon-class="text-white"
              default-opened>
            <BuyGoodsList :items="goodsItems"
                          :immediately-sale-customer="undefined"
                          :buy-num="parseInt(selectedBuyNum)"
                          :is-buy-request="true"
                          @goods-deleted="goodsDeleted"
                          @clear-items="clearItems"
                          :buy-description="selectedBuyDesc"
                          :selected-customer="undefined"/>
          </q-expansion-item>

        </div>
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
import ProductInfoSearchPanel from "@/components/productInfo/ProductInfoSearchPanel";
import ProductInfoSearchResult from "@/components/productInfo/ProductInfoSearchResult";
import BuyGoodsList from "@/components/Buys/‌BuyGoodsList";
import EventBus from "@/event-bus";
import {mapActions} from "vuex";

export default {
  name: "BuyRequest",
  components: {BuyGoodsList, ProductInfoSearchResult, ProductInfoSearchPanel},
  data() {
    return {
      selectedBuyNum: undefined,
      goodsItems: [],
      selectedBuyDesc: undefined,
    }
  },
  methods: {
    ...mapActions({
      getProductListBuGroupID: 'Products/getByGroupID',
      getCustomerInfo: 'Customers/get_customer_info',
      getOrderDetails: 'Buys/getOrderDetails',
      getOrder: 'Buys/getOrder'
    }),
    showCustomerInfo() {
      this.customerInfoDialog = true
    },
    goodsDeleted(args) {
      const founded = this.goodsItems.findIndex(item => item.Goods_ID === args.Goods_ID)
      this.$delete(this.goodsItems, founded)
    },
    customerSelected(args) {
      console.log(args)
    },
    immediatelyCustomerSelected(args) {
      console.log(args)
    },
    clearItems() {
      this.goodsItems = []
    },
    selectedGood(args) {
      const cloneGoods = Object.assign({}, args)
      cloneGoods.BuyLast_Price = cloneGoods.BuyLast_Price ? cloneGoods.BuyLast_Price : cloneGoods.BuyDay_Price
      const founded = this.goodsItems.find(item => item.Goods_ID === cloneGoods.Goods_ID)
      if (founded === undefined) {
        this.goodsItems.push(cloneGoods)
      } else {
        this.$q.notify({
          message: 'کالا تکراری است',
          type: 'negative',
          position: 'top',
          color: 'negative'
        })
      }
    },
    groupSelected(args) {
      EventBus.$emit('invoke-group-selected-event', args);
      this.getProductListBuGroupID(args.Group_ID).then((res) => {
        this.productList = res
        EventBus.$emit('invoke-productinfo-search-result-event', this.productList);
      })

    }
  },
  created() {
    if (this.$route.params.id) {
      this.selectedBuyNum = this.$route.params.id
      this.getOrder(
          {
            buyNum: this.$route.params.id,
            buyKind: 1
          }
      ).then((res) => {
        this.selectedBuyDesc = res[0].Buy_Desc
        this.getOrderDetails({
          buyNum: this.$route.params.id,
          buyKind: 1
        }).then((res) => {
          this.selectedBuyNum = this.$route.params.id
          this.goodsItems = res
        })
      })
    }
  }
}
</script>

<style scoped>

</style>